import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const PickerRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  '& .contract-picker-select': {
    flex: '1 1 auto',
    minWidth: 0,
  },
}));

export const InlineMessage = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  marginTop: theme.spacing(1),
}));

/* 선택 행 아래 계약 묶음 여백 */
export const LinkedList = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1.5),
}));

/* AI 초안 임시 표기 묶음 */
export const AiDraftStatusRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const AiDraftStatusRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  '& > span': {
    minWidth: 0,
    wordBreak: 'break-word',
  },
}));

export const ContractOptionRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  width: '100%',
  minWidth: 0,
}));

export const ContractOptionName = styled('span')({
  flex: '1 1 160px',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const ContractOptionMeta = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  fontSize: 12,
  color: 'var(--dk-text-secondary, #888d96)',
}));
